module.exports = __webpack_public_path__ + "img/avatar.6a73576.png";